<template>
    <div class="card" id="print-car-specs">
        <header class="card-header">
            <p class="card-header-title">ACTIONS:</p>
            <a href="#" class="card-header-icon" aria-label="more options">
                <span class="icon">
                    <i class="fas fa-exclamation-triangle"></i>
                </span>
            </a>
        </header>
        <div class="card-content">
            <div class="content">
                <div class="field">
                    <div class="control">
                        <a class="button is-danger is-fullwidth" @click="openSingleCarDeleteModal">DELETE THIS CAR</a>
                    </div>
                </div>
                <div class="field">
                    <div class="control">
                        <a class="button is-theme-primary is-fullwidth" @click="openSingleCarTransferModal">[{{ car.manager.name }}] TRANSFER CAR</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['car'],
        methods: {
            openSingleCarDeleteModal(){
                this.$store.dispatch('setSingleCarDeleteModalStatus', true)
            },
            openSingleCarTransferModal(){
                this.$store.dispatch('setSingleCarTransferModalStatus', true)
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Cars/Car/Details/DeleteCar.vue